import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode, memo } from 'react';
import isEqual from 'react-fast-compare';

type Props = {
    body: ReactNode;
    className?: string;
    header: ReactNode;
};

const DescriptionSectionComponent = ({ body, className, header }: Props) => {
    return (
        <div className={cn('mb-lg p-0 last:!mb-0 print:mx-auto', className)}>
            <BodyPrimary className="mb-xs text-text-secondary">
                {typeof header === 'string' ? <FormattedMessage id={header} /> : header}
            </BodyPrimary>
            <BodyPrimary className="relative whitespace-pre-wrap print:!my-[0.5em] print:!whitespace-normal [&_*]:!max-w-full [&_a]:text-primary-500 [&_a:hover]:text-primary-400 [&_a:hover]:no-underline">
                {body}
            </BodyPrimary>
        </div>
    );
};

export const DescriptionSection = memo(DescriptionSectionComponent, isEqual);
